import { GameCommunicationMessageType } from '@pp/core/src/controllers/gameCommunication/types';
import { toastActions } from '@pp/core/src/store/slices/toast/slice';

import { Bets } from '../../../config/bets';
import { GameStore } from '../../../store/GameStore';

import { GameComunicationCashOutProcessor } from './GameComunicationCashOutProcessor';

type cashoutMsg = GameCommunicationMessageType & {
  bc: Bets;
  playerAmt: string;
  playerTotalAmt: string;
  bc1: string;
  bc2: string;
  jackpot: string;
  maxCap: string;
};
export class GameComunicationAutoCashOutWinProcessor extends GameComunicationCashOutProcessor {
  messageName = 'hf_win';
  delay = 0;
  process(message: cashoutMsg, store: GameStore): void {
    if (message.maxCap === 'true') {
      store.dispatch(toastActions.createToast('MAX_PAYOUT_REACHED'));
    }
    super.process(message, store);
  }
}
